// import creditsIcon from "../../assets/icons/peppa_coin.png";
//import { Alert, AlertDescription } from "../../../components/ui/alert";
import { useNavigate } from "react-router-dom";
import { RouterPath } from "../../assets/dictionary/RouterPath";
import DataService from "../../components/auth/Service";
import { toast } from "sonner";
import { trackEvent, trackOncePerSession } from "../../lib/matomo";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader } from "../../components/ui/card";
import peppaLogo from "../../assets/icons/peppa_logo_blue.svg";
import { Textarea } from "../../components/ui/textarea";
import { Badge } from "../../components/ui/badge";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { BadgeInfo, HandCoins, MapPin, UsersRound, Rocket, BellRing, ArrowLeft, LockIcon, TriangleAlertIcon, Building2 } from "lucide-react";
import { SearchableMultiSelect } from "./MultiSelectComponents";
import { cn } from "../../lib/utils";
import { ThemeToggle } from "../../components/ui/theme-toggle";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";

import { useState, useEffect, useCallback } from "react";
import NotificationService from "./NotificationService";
import { useUser } from "../../context/UserContext";

const capitalizeWords = (str) => {
  return str
    .split(" ")
    .map(word =>
      word
        .split("-")
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join("-")
    )
    .join(" ");
};

const transformAPIDataToOptions = (apiData) => {
  return apiData.map((item, index) => ({
    id: index + 1,
    name: capitalizeWords(item)
  }));
};

// const SearchableMultiSelect = ({ label, options, selectedIds, onToggle, placeholder }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   const selectedItems = options.filter(opt => selectedIds.includes(opt.id));

//   // Filtrer les options en fonction de la recherche
//   const filteredOptions = options.filter(opt =>
//     opt.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Limiter l'affichage pour les performances
//   const displayedOptions = filteredOptions.slice(0, 100);

//   return (
//     <div className="relative">
//       <Label className="text-foreground">{label}</Label>
//       <div className="relative">
//         <button
//           type="button"
//           onClick={() => setIsOpen(!isOpen)}
//           className="mt-2 w-full rounded-md border border-border/50 bg-card/90 backdrop-blur-sm px-3 py-2 text-left text-sm text-foreground hover:bg-accent/50 focus:outline-none focus:ring-2 focus:ring-ring"
//         >
//           {selectedItems.length === 0 ? (
//             <span className="text-muted-foreground">{placeholder}</span>
//           ) : (
//             <div className="flex flex-wrap gap-1">
//               {selectedItems.map(item => (
//                 <Badge key={item.id} variant="secondary" className="inline-flex items-center gap-1">
//                   {item.name}
//                   <XCircle
//                     className="w-3 h-3 cursor-pointer hover:text-destructive"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       onToggle(item.id);
//                     }}
//                   />
//                 </Badge>
//               ))}
//             </div>
//           )}
//         </button>

//         {isOpen && (
//           <>
//             <div
//               className="fixed inset-0 z-10"
//               onClick={() => {
//                 setIsOpen(false);
//                 setSearchTerm("");
//               }}
//             />
//             <div className="absolute z-20 mt-1 w-full rounded-md border border-border/50 bg-card/95 backdrop-blur-sm shadow-lg">
//               {/* Barre de recherche */}
//               <div className="p-2 border-b border-border/40">
//                 <div className="relative">
//                   <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-muted-foreground" />
//                   <input
//                     type="text"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     placeholder="Rechercher..."
//                     className="w-full pl-9 pr-3 py-2 text-sm rounded-md border border-border/50 bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
//                     onClick={(e) => e.stopPropagation()}
//                   />
//                 </div>
//               </div>

//               {/* Liste des résultats */}
//               <div className="max-h-60 overflow-auto">
//                 {displayedOptions.length === 0 ? (
//                   <div className="px-3 py-4 text-sm text-muted-foreground text-center">
//                     Aucun résultat trouvé
//                   </div>
//                 ) : (
//                   <>
//                     {displayedOptions.map(option => {
//                       const isSelected = selectedIds.includes(option.id);
//                       return (
//                         <div
//                           key={option.id}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             onToggle(option.id);
//                           }}
//                           className={`px-3 py-2 cursor-pointer hover:bg-accent/40 flex items-center justify-between ${isSelected ? 'bg-accent/30' : ''
//                             }`}
//                         >
//                           <span className="text-sm text-foreground">{option.name}</span>
//                           {isSelected && <Check className="w-4 h-4 text-primary" />}
//                         </div>
//                       );
//                     })}
//                     {filteredOptions.length > 100 && (
//                       <div className="px-3 py-2 text-xs text-muted-foreground text-center border-t border-border/40">
//                         {filteredOptions.length - 100} résultats supplémentaires... Affinez votre recherche.
//                       </div>
//                     )}
//                   </>
//                 )}
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// const MultiSelect = ({ label, options, selectedIds, onToggle, placeholder }) => {
//   const [isOpen, setIsOpen] = useState(false);

//   const selectedItems = options.filter(opt => selectedIds.includes(opt.id));

//   return (
//     <div className="relative">
//       <Label className="text-foreground">{label}</Label>
//       <div className="relative">
//         <button
//           type="button"
//           onClick={() => setIsOpen(!isOpen)}
//           className="mt-2 w-full rounded-md border border-border/50 bg-card/90 backdrop-blur-sm px-3 py-2 text-left text-sm text-foreground hover:bg-accent/50 focus:outline-none focus:ring-2 focus:ring-ring"
//         >
//           {selectedItems.length === 0 ? (
//             <span className="text-muted-foreground">{placeholder}</span>
//           ) : (
//             <div className="flex flex-wrap gap-1">
//               {selectedItems.map(item => (
//                 <Badge key={item.id} variant="secondary" className="inline-flex items-center gap-1">
//                   {item.name}
//                   <XCircle
//                     className="w-3 h-3 cursor-pointer hover:text-destructive"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       onToggle(item.id);
//                     }}
//                   />
//                 </Badge>
//               ))}
//             </div>
//           )}
//         </button>

//         {isOpen && (
//           <>
//             <div
//               className="fixed inset-0 z-10"
//               onClick={() => setIsOpen(false)}
//             />
//             <div className="absolute z-20 mt-1 w-full rounded-md border border-border/50 bg-card/95 backdrop-blur-sm shadow-lg max-h-60 overflow-auto">
//               {options.map(option => {
//                 const isSelected = selectedIds.includes(option.id);
//                 return (
//                   <div
//                     key={option.id}
//                     onClick={() => onToggle(option.id)}
//                     className={`px-3 py-2 cursor-pointer hover:bg-accent/40 flex items-center justify-between ${isSelected ? 'bg-accent/30' : ''
//                       }`}
//                   >
//                     <span className="text-sm text-foreground">{option.name}</span>
//                     {isSelected && <Check className="w-4 h-4 text-primary" />}
//                   </div>
//                 );
//               })}
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

export default function CreateAlertPage() {
  const [notifications, setNotifications] = useState([]);
  const [notificationsLoaded, setNotificationsLoaded] = useState(true);
  const [activeNotificationId, setActiveNotificationId] = useState(null);
  // Gestion intelligente de la sidebar (même logique que ChatModern / CopilotModern)
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const mobile = window.innerWidth < 1024;
    if (mobile) return false;
    const savedState = localStorage.getItem("chat-sidebar-open");
    return savedState !== null ? JSON.parse(savedState) : true;
  });
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 1024);
  const [notificationToDelete, setNotificationToDelete] = useState(null);
  const [showCreationPanel, setShowCreationPanel] = useState(false);

  // États pour le formulaire de création
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [selectedLocalities, setSelectedLocalities] = useState([]);
  const [selectedCallTypes, setSelectedCallTypes] = useState([]);
  const [selectedCompanyTypes, setSelectedCompanyTypes] = useState([]);
  const [selectedEmitters, setSelectedEmitters] = useState([]);

  const { user, resetUserInfo } = useUser();
  const navigate = useNavigate();
  const plan = user?.type_abonnement ?? "Aucun";

  useEffect(() => {
    trackOncePerSession("notification_opened", () => trackEvent("notification", "opened"));
  }, []);


  const [all_Localities, setAll_Localities] = useState([]);
  const [all_CallTypes, setAll_CallTypes] = useState([]);
  const [all_CompanyTypes, setAll_CompanyTypes] = useState([]);
  const [all_Emitters, setAll_Emitters] = useState([]);


  const fetch_all_filters = useCallback(async () => {
    try {
      const localitiesRes = await NotificationService.getLocalities();
      setAll_Localities(transformAPIDataToOptions(localitiesRes.data));
      const callTypesRes = await NotificationService.getTypeOfCalls();
      setAll_CallTypes(transformAPIDataToOptions(callTypesRes.data));
      const companyTypesRes = await NotificationService.getTypeOfCompanies();
      setAll_CompanyTypes(transformAPIDataToOptions(companyTypesRes.data));
      const emittersRes = await NotificationService.getEmitters();
      setAll_Emitters(transformAPIDataToOptions(emittersRes.data));
    } catch (error) {
      console.error("Error fetching filter data:", error);
    }
  }, []);

  const fetch_all_notifications = useCallback(async () => {
    setNotificationsLoaded(false);
    try {
      const notificationsRes = await NotificationService.getNotification();
      setNotifications(notificationsRes.data);
      setNotificationsLoaded(true);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  }, []);

  useEffect(() => {
    fetch_all_filters();
    fetch_all_notifications();
  }, [fetch_all_filters, fetch_all_notifications]);

  // Sauvegarder l'état de la sidebar uniquement sur desktop (clé partagée)
  useEffect(() => {
    const mobile = window.innerWidth < 1024;
    if (!mobile) {
      localStorage.setItem("chat-sidebar-open", JSON.stringify(sidebarOpen));
    }
  }, [sidebarOpen]);

  // Détecter les changements de taille d'écran (auto-close mobile, restore desktop)
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      if (mobile) {
        setSidebarOpen(false);
      } else {
        const savedState = localStorage.getItem("chat-sidebar-open");
        setSidebarOpen(savedState !== null ? JSON.parse(savedState) : true);
      }
      setIsMobile(mobile);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [sidebarOpen]);

  const handleNewNotification = () => {
    try { trackEvent("notification", "create_clicked"); } catch (_) { }
    setShowCreationPanel(true);
    setActiveNotificationId(null);
    // Réinitialiser le formulaire
    setTitle("");
    setDescription("");
    setSelectedLocalities([]);
    setSelectedCallTypes([]);
    setSelectedCompanyTypes([]);
    setSelectedEmitters([]);
  };

  const handleSelectNotification = (notificationId) => {
    try { trackEvent("notification", "selected"); } catch (_) { }
    setActiveNotificationId(notificationId);
    setShowCreationPanel(false);
  };

  const hasAtLeastOneCriteria =
    selectedLocalities.length > 0 ||
    selectedCallTypes.length > 0 ||
    selectedCompanyTypes.length > 0 ||
    selectedEmitters.length > 0;

  const handleSubmitNotification = () => {
    if (!title.trim() || !hasAtLeastOneCriteria) {
      toast.error("Veuillez remplir le nom et au moins un critère de filtrage.");
      try { trackEvent("notification", "create_validation_error"); } catch (_) { }
      return;
    }

    const localitiesString = all_Localities
      .filter(loc => selectedLocalities.includes(loc.id))
      .map(loc => loc.name)
      .join(", ");

    const callTypesString = all_CallTypes
      .filter(ct => selectedCallTypes.includes(ct.id))
      .map(ct => ct.name)
      .join(", ");

    const companyTypesString = all_CompanyTypes
      .filter(ct => selectedCompanyTypes.includes(ct.id))
      .map(ct => ct.name)
      .join(", ");

    const emittersString = all_Emitters
      .filter(e => selectedEmitters.includes(e.id))
      .map(e => e.name)
      .join(", ");

    const newNotification = {
      user_id: null,
      title: title,
      description: description,
      locality: localitiesString || null,
      type_of_call: callTypesString || null,
      type_of_company: companyTypesString || null,
      emitter: emittersString || null,
      sent_at: null
    };

    NotificationService.postNotification(newNotification)
      .then(response => {
        console.log("Notification créée avec succès :", response.data);
        setNotifications(prev => [...prev, response.data]);
        setShowCreationPanel(false);
        toast.success("Demande de veille créée !");
        try { trackEvent("notification", "notification_created"); } catch (_) { }
        navigate(RouterPath.ALERTS);
      })
      .catch(error => {
        console.log("Erreur lors de la création de la notification :", error);
        if (error.response && error.response.status === 402) {
          toast.error("Il faut un abonnement pour créer une notification.");
          try { trackEvent("notification", "create_blocked_no_subscription"); } catch (_) { }
          return;
        }
        console.error("Erreur lors de la création de la notification :", error);
        toast.error("Une erreur est survenue lors de la création de la notification.");
        try { trackEvent("notification", "create_error"); } catch (_) { }
      });
    // Pour la démo, on affiche un message
  };

  const handleClickLogOut = async (e) => {
    e.preventDefault();
    try {
      await DataService.logout();
      resetUserInfo();
      navigate(RouterPath.LOGIN);
    } catch (error) {
      console.error(error);
    }
  };

  const toggleLocality = (id) => {
    setSelectedLocalities(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const toggleCallType = (id) => {
    setSelectedCallTypes(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const toggleCompanyType = (id) => {
    setSelectedCompanyTypes(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const toggleEmitter = (id) => {
    setSelectedEmitters(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const getNotificationTitle = (notification) => {
    return notification.title || "Notification";
  };

  const confirmDeleteNotification = (notification) => {
    try { trackEvent("notification", "delete_clicked"); } catch (_) { }
    setNotificationToDelete(notification);
  };

  const handleDelete = (notificationId) => {
    NotificationService.deleteNotification(notificationId)
      .then(response => {
        if (response.data > 0) {
          fetch_all_notifications();
          if (activeNotificationId === notificationId) {
            setActiveNotificationId(null);
          }
          toast.success("Notification supprimée avec succès.");
          try { trackEvent("notification", "deleted"); } catch (_) { }
        } else {
          toast.error("Vous ne pouvez pas supprimer cette notification.");
          try { trackEvent("notification", "delete_forbidden"); } catch (_) { }
        }
      })
      .catch(error => {
        console.error("Erreur lors de la suppression de la notification :", error);
        toast.error("Une erreur est survenue lors de la suppression de la notification.");
        try { trackEvent("notification", "delete_error"); } catch (_) { }
      });
    setNotificationToDelete(null);
  };


  return (
    <div className="min-h-screen relative app-page-gradient">
      <div className="max-w-5xl mx-auto px-4 py-8 space-y-6">
        {/* Main Content */}
        <div className="top-4 z-10 hidden md:block">
          <Button
            variant="ghost"
            onClick={() => navigate(RouterPath.ALERTS)}
            className="text-foreground"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Retour
          </Button>
        </div>
        <div>
          <div className="flex items-center gap-2 mb-2 pt-10 md:pt-0 wrap-balance">
            <BellRing className="hidden sm:flex items-center w-5 h-5 text-primary" />
            <h1 className="text-4xl font-bold text-foreground">
              Paramétrer une nouvelle <span className="text-primary">veille IA</span>
            </h1>
          </div>
          <p className="text-muted-foreground">
            Définissez les paramètres de recherche pour que notre intelligence artificielle identifie les opportunités de financement les plus pertinentes pour votre organisation.
          </p>
        </div>
        {plan === "Aucun" && (
          <div className="grid grid-cols-1 gap-4">
            <Card className="glass-card py-10">
              <CardContent className="p-5 flex flex-col items-center text-center gap-4">
                <div className="flex flex-col items-center gap-3">
                  <div className="flex items-center gap-2">
                    <TriangleAlertIcon className="w-5 h-5 text-yellow-500 shrink-0" />
                    <h3 className="text-xl font-semibold text-foreground">
                      Aucun abonnement actif
                    </h3>
                  </div>
                  <p className="text-muted-foreground max-w-lg text-sm">
                    Souscrivez à un plan pour créer vos veilles et recevoir des rapports personnalisés.
                  </p>
                </div>
                <Button onClick={() => navigate(RouterPath.BILLING)}>
                  Mettre à niveau
                </Button>
              </CardContent>
            </Card>
          </div>
        )}
        {/* Grid Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 max-w-5xl w-full mx-auto">
          {/* First Column */}
          <div className="flex flex-col items-center p-4 w-full gap-6 mx-auto">
            <Card className="glass-card w-full">
              <CardHeader className="pb-0">
                <h3 className="flex items-center gap-2 text-2xl font-semibold text-foreground"><BadgeInfo className="text-primary" />Informations du projet</h3>
              </CardHeader>

              <CardContent className="p-6 space-y-1">
                <div className="space-y-6">
                  {/* Titre */}
                  <div>
                    <Label className="text-foreground">Nom du projet</Label>
                    <Input
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="Entrez le nom du projet"
                      className="mt-2"
                    />
                  </div>

                  {/* Description */}
                  <div>
                    <Label className="text-foreground">Description détaillée pour l'IA</Label>
                    <Textarea
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Décrivez les objectifs techniques, les verrous technologiques et l'impact sociétal de votre projet..."
                      rows={4}
                      className="mt-2"
                    />
                    <p className="text-xs mt-2 text-muted-foreground italic">Plus la description est précise, plus l'analyse de pertinence par l'IA sera fine.</p>
                  </div>
                </div>
              </CardContent>
            </Card>
            <Card className="glass-card w-full">
              <CardHeader className="pb-0">
                <h3 className="flex items-center gap-2 text-2xl font-semibold text-foreground"><MapPin className="text-primary" />Périmètre géographique</h3>
              </CardHeader>
              <CardContent className="p-6 space-y-1">
                {/* Localités */}
                <SearchableMultiSelect
                  label=""
                  options={all_Localities}
                  selectedIds={selectedLocalities}
                  onToggle={toggleLocality}
                  placeholder="Sélectionnez les territoires couverts par la veille"
                />
              </CardContent>
            </Card>

          </div>
          {/* Second Column */}
          <div className="flex flex-col items-center p-4 w-full gap-6">
            <Card className="glass-card w-full">
              <CardHeader className="pb-0">
                <h3 className="flex items-center gap-2 text-2xl font-semibold text-foreground"><HandCoins className="text-primary" />Type d'aides</h3>
              </CardHeader>
              <CardContent className="p-6 space-y-1">
                <SearchableMultiSelect
                  label="Types d'aides"
                  options={all_CallTypes}
                  selectedIds={selectedCallTypes}
                  onToggle={toggleCallType}
                  placeholder="Sélectionnez un ou plusieurs types d'aides"
                />
              </CardContent>
            </Card>
            <Card className="glass-card w-full">
              <CardHeader className="pb-0">
                <h3 className="flex items-center gap-2 text-2xl font-semibold text-foreground"><UsersRound className="text-primary" />Bénéficiaire(s)</h3>
              </CardHeader>
              <CardContent className="p-6 space-y-1">
                <SearchableMultiSelect
                  label="Types d'organismes bénéficiaires"
                  options={all_CompanyTypes}
                  selectedIds={selectedCompanyTypes}
                  onToggle={toggleCompanyType}
                  placeholder="Sélectionnez un ou plusieurs types d'organismes bénéficiaires"
                />
              </CardContent>
            </Card>
            <Card className="glass-card w-full">
              <CardHeader className="pb-0">
                <h3 className="flex items-center gap-2 text-2xl font-semibold text-foreground"><Building2 className="text-primary" />Émetteur de l'aide</h3>
              </CardHeader>
              <CardContent className="p-6 space-y-1">
                <SearchableMultiSelect
                  label="Émetteurs"
                  options={all_Emitters}
                  selectedIds={selectedEmitters}
                  onToggle={toggleEmitter}
                  placeholder="Sélectionnez un ou plusieurs émetteurs"
                />
              </CardContent>
            </Card>
          </div>
        </div>
            {/* Boutons d'action */}
            <Card className="glass-card max-w-2xl mx-auto mt-6 overflow-hidden">
              <CardContent className="p-6">
                <div className="flex items-center justify-end w-full gap-4">
                  <Button
                    onClick={handleSubmitNotification}
                    className="flex-1"
                    disabled={plan === "Aucun" || !title || !hasAtLeastOneCriteria}
                  >
                    {plan === "Aucun" ? <LockIcon className="w-4 h-4 mr-2" /> : <Rocket className="w-4 h-4 mr-2" />}
                    {plan === "Aucun" ? "Aucun abonnement actif" : "Créer la demande de veille"}
                  </Button>
                </div>
              </CardContent>
            </Card>
      </div >
    </div >

    // <Dialog
    //   open={!!notificationToDelete}
    //   onOpenChange={() => setNotificationToDelete(null)}
    // >
    //   <DialogContent className="sm:max-w-[400px] bg-background text-foreground border-border">
    //     <DialogHeader>
    //       <DialogTitle className="text-foreground">Supprimer la demande de veille</DialogTitle>
    //       <DialogDescription>
    //         Cette action est irréversible.
    //       </DialogDescription>
    //     </DialogHeader>

    //     <DialogFooter>
    //       <Button variant="outline" className="text-foreground" onClick={() => setNotificationToDelete(null)}>
    //         Annuler
    //       </Button>
    //       <Button
    //         variant="destructive"
    //         onClick={() => {
    //           handleDelete(notificationToDelete.id);
    //           setNotificationToDelete(null);
    //         }}
    //       >
    //         Supprimer
    //       </Button>
    //     </DialogFooter>
    //   </DialogContent>
    // </Dialog>
    // </div >
  );

}